module.exports = __webpack_public_path__ + "media/promo/lum2021/images/contestm-574e6b74c2e241da5546925b6e871205.png";